<lib-content-card *ngIf="homeTeam && awayTeam && layout !== minimalLayout"
                  class="content-card"
                  [layout]="layout"
                  [colorScheme]="colorScheme"
                  [title]="title"
                  [maxImageHeight]="orientation === 'portrait' ? 'unset' : null"
                  [picture]="picture"
                  [lazyLoadImage]="lazyLoadImage"
                  [showContent]="showContent"
                  [routerLink]="link">
</lib-content-card>
<div *ngIf="showDownloads" class="match-downloads">
  <a
    *ngIf="highlightVideoDownload"
    target="_blank"
    [href]="highlightVideoDownload"
    matTooltip="Highlights herunterladen"
  >
    <mat-icon>download</mat-icon>
    Highlights
  </a>
  <a
    *ngIf="replayVideoDownload"
    target="_blank"
    [href]="replayVideoDownload"
    matTooltip="Replay herunterladen"
  >
    <mat-icon>download</mat-icon>
    Replay
  </a>
</div>
<div *ngIf="layout !== minimalLayout" class="match-overlay">
  <div *ngIf="liveStreamStatus && showStatusBadge"
       class="status-chip overlay-left"
       [style.background-color]="liveStreamStatusColor">
    <mat-icon>play_circle</mat-icon>
    {{ minimalLiveStreamStatus }}
  </div>
  <div *ngIf="liveStreamStatus && shortDateString && !minute" class="date overlay-right">
    <span>{{ shortDateString }}</span>
    <mat-icon>calendar_today</mat-icon>
  </div>
  <div *ngIf="!liveStreamStatus && shortDateString" class="date overlay-left">
    <mat-icon>calendar_today</mat-icon>
    <span>{{ shortDateString }}</span>
  </div>
  <div *ngIf="!liveStreamStatus && timeString && !minute" class="date overlay-right">
    <span>{{ timeString }}</span>
  </div>
  <div *ngIf="minute" class="minute overlay-right">
    <span>{{ minute }}</span>
  </div>
  <div *ngIf="match.streaming_info?.paywall" class="abo-chip">
    <img src="assets/icons/fan.at/abo-logo.svg" alt="fan.at abo"/>
  </div>
</div>

<!-- Minimal Layout -->
<a *ngIf="layout === minimalLayout && homeTeam && awayTeam"
   class="minimal-card {{colorScheme.main}}"
   [ngClass]="{'live': minute}"
   [routerLink]="link">

  <!-- Do not show background color for now -->
  <!--lib-content-card-background
    *ngIf="minimalLiveStreamStatus && showStatusBadge"
    [color]="homeTeam.primary_color">
  </--lib-content-card-background-->

  <div class="minimal-header">
    <div *ngIf="minimalLiveStreamStatus && showStatusBadge"
         class="status-chip"
         [style.background-color]="liveStreamStatusColor">
      <mat-icon>play_circle</mat-icon>
      {{ minimalLiveStreamStatus }}
    </div>
    <span *ngIf="matchInfoLeft" class="minimal-status">{{ matchInfoLeft }}</span>
    <span *ngIf="matchInfoRight" class="minimal-status">{{ matchInfoRight }}</span>
  </div>

  <div class="minimal-team">
    <img [src]="homeTeam.pictures | logo" [alt]="homeTeam.name" loading="lazy"/>
    <span class="team-name">{{ homeTeam.abbreviation }}</span>
    <span class="score" *ngIf="homeScore">{{ homeScore }}</span>
  </div>
  <div class="minimal-team">
    <img [src]="awayTeam.pictures | logo" [alt]="awayTeam.name"/>
    <span class="team-name">{{ awayTeam.abbreviation }}</span>
    <span class="score" *ngIf="awayScore">{{ awayScore }}</span>
  </div>
</a>
